module.exports = __webpack_public_path__ + "static/media/btn_add_to_apple_wallet.31571f06.svg";